import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { backendRequest } from '../../api'
import Pages from '../../all/pages';

const PTCAdminHistory = ({ ws }) => {
    const [campaigns, setCampaigns] = useState([])
    const [fakePage, setFakePage] = useState(1)
    const [realPage, setRealPage] = useState(0)

    const history = useNavigate()
    const redirectToPage = (url) => history('/' + url)

    useEffect(() => {
        async function getCampaigns() {
            try {      
                const data = await backendRequest('/admin/campaign/campaigns/history', 'POST', {page: 0,})
                setCampaigns(data)
            } catch (e) {
                return
            }
        }
        
        getCampaigns()
    }, [])

    const dynamicallyLoadMorePages = async () => {
        let currentTotalPages = Math.round(campaigns.length / 8)
        if (currentTotalPages - 3 === fakePage) {
            setRealPage(realPage + 1)
            const data = await backendRequest('/admin/campaign/campaigns/history', 'POST', {page: realPage + 1})
            setCampaigns([...campaigns, ...data])
        }
    }

    function getStatusColor(status) {
        if (status === 'rejected') return 'red'
        if (status === 'approved') return 'green'
    }

    return (
        <>
            <div className='table'>
                <div className='table-header'>
                    <p>Username</p>
                    <p>Name</p>
                    <p>URL</p>
                    <p>Views Left</p>
                    <p>Status</p>
                    <p>Paid</p>
                    <p>Last Update</p>
                </div>

                {Array.isArray(campaigns) && campaigns.slice((fakePage - 1) * 8, (fakePage) * 8).map((campaign, index) => (
                    <div className='table-row' key={index}>
                        <div className='name clickable' onClick={() => redirectToPage(`admin/users/${campaign.buyer_userid}/offers`)}>
                            <img className='avatar' src={campaign.buyer_avatar} alt=''/>
                            <p>{campaign.buyer_name}</p>
                        </div>
                        <p>{campaign.campaign_name}</p>
                        <a href={campaign.campaign_url} target='_blank' rel='noreferrer'>View</a>
                        <p>{campaign.campaign_uses_remaining}</p>
                        <p className={getStatusColor(campaign.status)}>{campaign.status}</p>
                        <p>${Number(campaign.tokens_spent/1000).toFixed(2)}</p>
                        <p>{(new Date(Number(campaign.campaing_updated)))?.toLocaleString()}</p>
                    </div>
                ))}

                <Pages loadMorePages={dynamicallyLoadMorePages} maxPages={Math.ceil(campaigns?.length / 8)} curpage={fakePage} setPage={setFakePage}/>
            </div>

            <style jsx>{`
                .users-container {
                    width: 100%;
                }

                .title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: 600;
                    color: #F1C475;
                    margin: unset;
                }

                .table {
                    overflow-x: auto;
                }

                .table-header, .table-row {
                    background-color: #141A31;
                    display: flex;
                    border-radius: 12px;
                    padding: 0px 15px;
                    font-size: 14px;
                    align-items: center;
                    min-width: 675px;
                }

                .page {
                    opacity: 0.5;
                    cursor: pointer;
                    margin: unset;
                    margin-bottom: 0.5rem;
                }

                .active {
                    color: #4DAEFF;
                    opacity: 1;
                }

                .table-row {
                    margin-top: 15px;
                    transition: all .2s;
                }

                .table-row > * {
                    flex: 1;
                    text-align: center;
                }

                .table-row > a {
                    color: #4DAEFF;
                    text-decoration:none;
                }

                .table-header > * {
                    flex: 1;
                    text-align: center;
                    opacity: 0.5;
                }

                .green {
                    color: #4FAC7C;
                }

                .red {
                    color: #ac4f4f;
                }

                .blue {
                    color: #4F8DDE;
                }

                .clickable {
                    cursor: pointer;
                }

                .name {
                    display: flex;
                    gap: 15px;
                    align-items: center;
                    overflow: hidden;
                }

                .name:hover {
                    color: #4F8DDE;
                }
                
                .avatar {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                }

                .buttons {
                    display: flex;
                    gap: 5px;
                    justify-content: center;
                }

                .reject, .send, .edit {
                    border: unset;
                    outline: unset;
                    color: white;
                    border-radius: 3px;
                    cursor: pointer;
                    flex: 1;
                }

                .edit {
                    background-color: #4DAEFF;
                }

                .reject {
                    background-color: #ac4f4f;
                }

                .send {
                    background-color: #4FAC7C;
                }

                p {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .modal-container {
                    position: fixed;
                    display: flex;

                    width: 100%;
                    height: 100%;

                    background-color: rgba(0,0,0,0.3);
                    justify-content: center;
                    align-items: center;

                    top: 0;
                    left: 0;

                    z-index: 10;
                }

                .modal-center {
                    background-color: #21294D;

                    width: 250px;
                    height: 150px;
                    border-radius: 12px;
                    
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    gap: 10px;
                }

                .modal-center .buttons { 
                    width: 100%;
                    padding: 0px 25px;
                    border-box: box-sizing;
                }

                .gift-input {
                    background: #1C2344;
                    border-radius: 6px;
                    outline: unset;
                    border: unset;
                    color: white;
                    padding: 6px;
                }
            `}</style>
        </>
    );
};

export default PTCAdminHistory;